import { FC } from "react";
import { TColumnData } from "../../../../components/tables/table_column";
import Table from "../../../../components/tables/table";
import { getDateTimeView } from "../../../../helpers/datetime";
import { getCurrencyNumberWithOutSymbol } from "../../../../helpers/get-currency-number";
import { ArrowForwardIos } from "@mui/icons-material";
import { TCollectionInfo, TCollectionsFilters } from "../bloc/collectionsSlice";
import { getUpdatedCollections } from "../functions/collections_functions";
import { getCollectionStatusDisplayIcon } from "../../../../helpers/getText";

const CollectionsTable: FC<{
  collections: TCollectionInfo[];
  onClick: (index: number) => void;
  searchText: string;
  isCardCollpased: boolean;
  filters: TCollectionsFilters;
}> = ({ collections, onClick, searchText, isCardCollpased, filters }) => {
  const columns: TColumnData[] = [
    { text: "#", width: 5 },
    { text: "Trade Id / Loan Id", width: 10 },
    { text: "UTR", width: 16 },
    { text: "Created At", width: 15 },
    { text: "Customer", width: 15 },
    { text: "Payment source", width: 10 },
    { text: "Amount(₹)", width: 14, classes: "justify-end" },
    { text: "Status", width: 15 },
  ];

  const _buildRow = (index: number, collection: TCollectionInfo) => {
    const statusInfo = getCollectionStatusDisplayIcon({
      status: collection.status,
    });

    return [
      <>{index + 1}</>,
      <>{collection.prodId}</>,
      <>{collection.utr}</>,
      <>{getDateTimeView(collection.createdOn)}</>,
      <>{collection.customer}</>,
      <>{collection.paymentSource}</>,
      <div className="text-end">
        {getCurrencyNumberWithOutSymbol(collection.amount)}
      </div>,
      <div className="flex justify-between">
        <span className={statusInfo.color}>{statusInfo.label}</span>
        <div className="br-100 icon_bg w-[25px] h-[25px] flex items-center justify-center color-inactive">
          <ArrowForwardIos
            style={{
              fontSize: 16,
              color: "color-inactive",
            }}
          />
        </div>
      </div>,
    ];
  };

  const _getPayoutsList = () => {
    let updatedCollections = getUpdatedCollections(
      searchText,
      collections,
      filters,
    );
    return updatedCollections;
  };

  return (
    <Table
      columns={columns}
      data={_getPayoutsList().map((collection, index) =>
        _buildRow(index, collection),
      )}
      maxHeight={
        isCardCollpased ? "calc(100vh - 17rem)" : "calc(100vh - 21rem)"
      }
      onRowClick={onClick}
    />
  );
};

export default CollectionsTable;
